import { createContext, useContext } from "react";
export const HotkeyContext = createContext(undefined);
export function useHotkeyContext() {
    const context = useContext(HotkeyContext);
    if (!context) {
        throw new Error("useHotkeyContext must be used within a HotkeyProvider");
    }
    return {
        lock: context.lock,
        unlock: context.unlock,
        isLocked: context.isLocked,
    };
}
